import {registerOpenDialog, loadModal} from 'tfx-common/store/dialogs'

export default {
  methods: {
    dialogRegister(el) {
      registerOpenDialog({el: el})
    },
    loadModal(evt, el) {
      const closeAll = !!(el.dataset && el.dataset.dialogCloseAll)
      loadModal({el: el, closeAll: closeAll})
    }
  }
}
